import { Star, Quote } from "lucide-react";

const REVIEWS = [
    {
        name: "Sarah M.",
        location: "Dumbarton",
        rating: 5,
        text: "Hung six doors and assembled a wardrobe in an afternoon. Polite, on time and the price was exactly what was quoted. Will definitely use again.",
    },
    {
        name: "Iain R.",
        location: "Alexandria",
        rating: 5,
        text: "Fixed a leaking tap and put up a TV the same visit. Honest pricing and a really clean finish — couldn&apos;t ask for more.",
    },
    {
        name: "Claire W.",
        location: "Helensburgh",
        rating: 5,
        text: "Replaced a fence panel and sorted a couple of odd jobs we&apos;d been putting off for ages. Friendly, professional and tidy.",
    },
];

export default function Testimonials() {
    return (
        <section
            id="reviews"
            data-testid="testimonials-section"
            className="py-24 md:py-32 bg-slate-50"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
                    <div className="max-w-2xl">
                        <div className="text-xs uppercase tracking-[0.2em] text-amber-700 font-bold mb-4">
                            What clients say
                        </div>
                        <h2 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight text-slate-900">
                            Trusted by neighbours
                            <br />
                            across the area.
                        </h2>
                    </div>
                    <div
                        className="flex items-center gap-3"
                        data-testid="overall-rating"
                    >
                        <div className="flex">
                            {[...Array(5)].map((_, i) => (
                                <Star
                                    key={i}
                                    className="w-5 h-5 fill-amber-500 text-amber-500"
                                />
                            ))}
                        </div>
                        <div className="text-sm font-semibold text-slate-700">
                            Consistently 5-star feedback
                        </div>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                    {REVIEWS.map((r, i) => (
                        <div
                            key={i}
                            data-testid={`testimonial-card-${i}`}
                            className="relative bg-white border border-slate-200 rounded-xl p-7 hover:shadow-md transition-shadow"
                        >
                            <Quote className="absolute top-5 right-5 w-8 h-8 text-amber-100" />
                            <div className="flex gap-0.5 mb-4">
                                {[...Array(r.rating)].map((_, idx) => (
                                    <Star
                                        key={idx}
                                        className="w-4 h-4 fill-amber-500 text-amber-500"
                                    />
                                ))}
                            </div>
                            <p
                                className="text-slate-700 leading-relaxed text-[15px]"
                                dangerouslySetInnerHTML={{
                                    __html: `&ldquo;${r.text}&rdquo;`,
                                }}
                            />
                            <div className="mt-6 pt-5 border-t border-slate-100">
                                <div className="font-display font-bold text-slate-900">
                                    {r.name}
                                </div>
                                <div className="text-xs text-slate-500 uppercase tracking-wider mt-0.5">
                                    {r.location}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
